import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import {uniformType, uniformSource} from "_src/engine/constants";
import {mat4} from "_src/libs/gl-matrix";

import vertText from "_src/shaders/photo_view/photo_view.glslv";
import fragText from "_src/shaders/photo_view/photo_view.glslf";

export default class PhotoViewShader extends Shader {

  constructor(params = {}) {
    super(params);
    this.attachUniforms();
  }

  compile() {
    super.compile(vertText, fragText);
  }

  attachUniforms() {
    this.uniforms["u_text_diffuse"] = new Uniform(uniformType.INT1, 0, uniformSource.OBJECT);
    this.uniforms["u_text_undistortion"] = new Uniform(uniformType.INT1, 1, uniformSource.OBJECT);
    this.uniforms["u_model_matrix"] = new Uniform(uniformType.MAT4, mat4.create(), uniformSource.OBJECT);
    this.uniforms["u_view_proj_matrix"] = new Uniform(uniformType.MAT4, mat4.create(), uniformSource.SCENE);
    this.uniforms["u_alpha"] = new Uniform(uniformType.FLOAT1, 0, uniformSource.OBJECT);
  }

  //reimplementation
  initDirectives(params) {
    this._directives["USE_CAMERA"] = params.useCamera;
    this._directives["USE_UNDISTORTION"] = false;
  }

  updateObjectUniformValues(object) {
    mat4.copy(this.uniforms["u_model_matrix"].value, object.modelMatrix);
    this.uniforms["u_alpha"].value = object.properties.diffuseColor[3];
  }

  updateSceneUniformValues(scene) {
    const camera = scene.camera;
    mat4.copy(this.uniforms["u_view_proj_matrix"].value, camera.viewProjMat);
  }

}
